import getApp from "../getApp";

export default async function ({data, appSlug}) {
    return (await getApp(appSlug)).schema({data});
}
